import type { QBankStructureLevelItemWithLevel } from '@exam-management/qbs-provider';

export enum CheckboxType {
  Indeterminate = 'indeterminate',
  Checked = 'checked',
  Unchecked = 'unchecked',
}

export interface QBankStructureCVForm {
  contentIds: {
    [key: string]: Pick<DisplayQBankStructureLevelItem, 'parentLevelItemId'> & {
      type: DisplayQBankStructureLevelItem['qBankStructureLevel']['category'];
      isVisible: boolean;
    };
  };
}

export type QBankStructureCVRaw = Omit<DisplayQBankStructureLevelItem, 'children'> & {
  isVisible: boolean;
};

export interface DisplayQBankStructureLevelItem extends QBankStructureLevelItemWithLevel {
  children?: DisplayQBankStructureLevelItem[];
}
